import labels from './labels/list/sagas'
import createLabel from './labels/create/sagas'
import destroyLabel from './labels/destroy/sagas'
import updateLabel from './labels/update/sagas'
import detailLabel from './labels/details/sagas'

import createAccount from './account/create/sagas'
import accountDetails from './account/details/sagas'
import updateAccount from './account/update/sagas'

import rules from './rules/list/sagas'
import createRule from './rules/create/sagas'
import destroyRule from './rules/destroy/sagas'
import updateRule from './rules/update/sagas'
import detailRule from './rules/details/sagas'

export default [labels, createLabel, destroyLabel, updateLabel, detailLabel, createAccount, accountDetails, updateAccount, rules, createRule, destroyRule, updateRule, detailRule]
